const GALLERY_IMAGES = [
    { src: "images/Natureinthefields.jpg", width: 3600, height: 2400 },
    { src: "images/mrs-potts.jpg", width: 1080, height: 793 },
    { src: "images/In_Twilight.jpg", width: 3253, height: 2195 },
    { src: "images/Aunt_March_3.jpg", width: 2792, height: 3917 },
    { src: "images/Aunt_March_2.jpg", width: 1064, height: 1858 },
    { src: "images/Aunt_March_1.jpg", width: 1539, height: 1862 },
    { src: "images/Alice_Paul.jpg", width: 600, height: 590 },
    { src: 'images/Arms_and_the_Man.jpg', width: 2602, height: 2532 },
    { src: 'images/Crimes_of_the_Heart.jpg', width: 2365, height: 3367 },
    { src: 'images/I_Hate_Hamlet.jpg', width: 2659, height: 1992 },
    { src: 'images/I_Hate_Hamlet_Act_5.jpg', width: 2900, height: 2242 },
    { src: 'images/Kate_in_Taming_of_the_Shrew.jpg', width: 2749, height: 3823 },
    { src: 'images/Lend_Me_a_Tenor.jpg', width: 2590, height: 3450 },
    { src: 'images/On_the_Verge_Finale.jpg', width: 945, height: 528 },
    { src: 'images/On_the_Verge_Trio.jpg', width: 1062, height: 544 },
    { src: 'images/On_the_Verge_Whipped_Cream.jpg', width: 743, height: 545 },
    { src: 'images/Romeo_and_Juliet.jpg', width: 4440, height: 3210 },
    { src: 'images/The_Crucible.jpg', width: 3707, height: 2780 },
    { src: 'images/The_Locket_Oliver.jpg', width: 761, height: 633 },
    { src: 'images/Three_Sisters.jpg', width: 2166, height: 2095 },
    { src: 'images/Tis_Pity_She\'s_A_Whore.jpg', width: 2123, height: 1764 }
];

module.exports = { GALLERY_IMAGES };
